import * as React from "react";
import axios from 'axios';
import ScenePopupComponent from '../navigation/scenePopup.Component';

interface IProps {

}

interface IState {
    selectedId: number;
    data: any;
    isPopupVisivle: boolean;
    popupContent: any;
}

class EcoStruxureComponent extends React.Component<IProps, IState>{
    constructor(props) {
        super(props);

        this.state = {
            selectedId: 0,
            data: null,
            isPopupVisivle: false,
            popupContent: null
        }
    }

    componentDidMount() {
        axios.get('/assets/ecoStruxureConfig.json') // JSON File Path
            .then(res => {
                if (res.data) {
                    console.log(res.data)
                    this.setState({ data: res.data })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    getTitle = (title: string) => {
        let r = title.split(/\n/);
        return r.map((g: string, index: number) => <p key={index + "parag"} style={{ margin: 0 }}>{g}</p>)
    }

    openPopup = (content) => {
        let popupcontent = (
            <>
                <div className="image-container">
                    <img alt="" src={content.imgSrc} width="100%" height="100%"></img>
                </div>

                <div className="content-container">
                    <div className="popup-category">{content.category}</div>

                    <div className="popup-title">{content.title}</div>

                    <div className="popup-content">{content.content}</div>
                </div>
            </>)
        this.setState({ isPopupVisivle: true, popupContent: popupcontent })
    }

    handleCancelPopupButton = () => {
        this.setState({ isPopupVisivle: false })
    }

    render() {
        const { data } = this.state;
        return (
            <>
                <div className="menu-layoult-container">
                    {data ?
                        <>
                            <h1 className="blocks-title">EcoStruxure</h1>
                            <div className="blocks-container">
                                <div className="block">
                                    <div className="block-item" style={{ marginTop: 50 }}>
                                        Apps, <br />
                                        Analytics <br />
                                        & Services
                                </div>
                                    <div className="block-item">
                                        Edge <br />
                                        Control
                                </div>
                                    <div className="block-item">
                                        Connected <br />
                                        Products
                                </div>
                                </div>
                                <div className="block">
                                    <div className="block-item-full">
                                        <div className="vertical-text">
                                            End-to-End Cybersecurity - Cloud and/or On Premise
                                    </div>
                                    </div>
                                </div>
                                <div className="block" style={{ width: 'calc(100% - 250px)' }}>
                                    <div className="block-item-max-width-first">

                                        {data.blocks.firstRow.map(r => {
                                            return <div key={r.id} style={r.style} className="data-item" onClick={() => this.openPopup(r.popup)}>
                                                <div style={{ height: "calc(100% - 60px)", textAlign: 'center' }}>
                                                    <img alt="" src={r.imgSrc} width={"80%"} height={"100%"}></img>
                                                </div>
                                                <div style={{ textAlign: "center", height: '85px' }}>{this.getTitle(r.title)}</div>
                                            </div>
                                        })}


                                    </div>
                                    <div className="block-item-max-width">

                                    </div>
                                    <div className="block-item-max-width">

                                    </div>
                                </div>
                            </div>
                        </>
                        : null}
                </div>
                <ScenePopupComponent
                    isVisible={this.state.isPopupVisivle}
                    content={this.state.popupContent}
                    handleCancelButton={this.handleCancelPopupButton} />
            </>
        );
    }
}

export default EcoStruxureComponent;